import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { swalErrorTimer } from '../../helpers/swalHelper';

const exportExcel = async (data, fileName, columns = [] ) => {
  try {
    if (!data.length) {
      alert('ไม่พบข้อมูลสำหรับ export');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Data');

    if (columns.length > 0) {
      worksheet.columns = columns;
      data.forEach(row => {
        const filteredRow = {};
        columns.forEach(col => {
          filteredRow[col.key] = row[col.key];
        });
        worksheet.addRow(filteredRow);
      });
    } else {
      worksheet.columns = Object.keys(data[0]).map(key => ({
        header: key,
        key: key,
        width: 20
      }));
      data.forEach(row => {
        worksheet.addRow(row);
      });
    }

    worksheet.getRow(1).eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFCCE5FF' }
      };
      cell.font = { bold: true };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, fileName);
  } catch (error) {
    swalErrorTimer({title: 'ไม่สามารถดาวน์โหลดข้อมูลได้'});
    console.error(error);
  }
};

export default exportExcel;